import React from 'react'

import { session } from '../load-config'

function ValidateSessionId(WrappedComponent) {
  return (props) => {
    const sessionId = session.getSessionId()

    if (!sessionId) {
      return window.location.href = '/'
    }

    return (
      <WrappedComponent {...props} />
    )
  }
}

export default ValidateSessionId
